import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { colors } from '@guryou/colors';
import { Block, DateTimePicker, FlexRow, Form, HiddenField, PaperBlock, RadioGroupBox, Spinner, TextBox } from '@guryou/html-components';
import { stateIsLoading, updateUserProfile, useCurrentUser, useGender } from '@guryou/redux';
import { DateTimePicker as MuiDateTimePicker, KeyboardDatePicker, KeyboardTimePicker } from '@material-ui/pickers';
import Agreements from './Agreements';
import ChangePassword from './ChangePassword';
import UserImage from './UserImage';

const EditProfile = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const update = useSelector(state => state.user.update);

  const genderOptions = useGender();

  const { user } = useCurrentUser();

  const handleSubmit = values => {
    dispatch(updateUserProfile(values));
  };

  if (!user || stateIsLoading(update)) {
    return <Spinner />;
  }

  return (
    <section class="py-16">
      <div class="container mx-auto px-4">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-8 p-6 rounded-lg shadow-md bg-white">
          <div>
            <h2 class="text-xl font-bold mb-4">{t('PROFILE.accountInfo')}</h2>
            <UserImage acc={user} />
            <form action="#">
              <HiddenField name="role" value={user.role} />
              <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label class="block text-sm font-medium mb-1">{t('GENERAL.username')}</label>
                  <input
                    name="name"
                    value={user.name}
                    type="text"
                    class="w-full  border border-gray-300 rounded-lg px-4 py-2"
                    placeholder="BonnieG"
                  />
                </div>
                <div>
                  <label class="block text-sm font-medium mb-1">{t('GENERAL.name')}</label>
                  <input
                    name="firstname"
                    value={user.firstname}
                    type="text"
                    class="w-full  border border-gray-300 rounded-lg px-4 py-2"
                    placeholder="Bonnie Green"
                  />
                </div>
                <div>
                  <label class="block text-sm font-medium mb-1">{t('GENERAL.surname')}</label>
                  <input
                    name="lastname"
                    label={t('GENERAL.surname')}
                    value={user.lastname}
                    type="text"
                    class="w-full border border-gray-300 rounded-lg px-4 py-2"
                    placeholder="Bonnie Green"
                  />
                </div>
                <div>
                  <label class="block text-sm font-medium mb-1">{t('GENERAL.dateofbirth')}</label>
                  <div class="w-full border border-gray-300 rounded-lg px-4 py-[5px] bg-white">
                    <DateTimePicker
                      InputProps={{
                        className: 'before:hidden',
                      }}
                      dateFieldName="birthday"
                      label=""
                      value={user.birthday}
                      disablePast={false}
                      margin="none"
                    />
                  </div>
                </div>
                <div>
                  <label class="block text-sm font-medium mb-1">{t('PROFILE.gender')}</label>
                  <RadioGroupBox row={true} name="gender" value={user.gender} options={genderOptions} />
                </div>
              </div>
              <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-10">
                <div>
                  <label class="block text-sm font-medium mb-1">{t('GENERAL.email')}</label>
                  <input
                    name="email"
                    value={user.email}
                    required={true}
                    type="email"
                    class="w-full border border-gray-300 rounded-lg px-4 py-2"
                    placeholder={t('GENERAL.email')}
                  />
                </div>
                <div>
                  <label class="block text-sm font-medium mb-1">{t('GENERAL.phone')}</label>
                  <input
                    name="phone"
                    value={user.phone}
                    type="text"
                    class="w-full  border border-gray-300 rounded-lg px-4 py-2"
                    placeholder={t('GENERAL.phone')}
                  />
                </div>
              </div>
              <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
                <div>
                  <label class="block text-sm font-medium mb-1">{t('GENERAL.address')}</label>
                  <input
                    name="address"
                    value={user.address}
                    class="w-full  border border-gray-300 rounded-lg px-4 py-2"
                    placeholder={t('GENERAL.address')}
                  />
                </div>
                <div>
                  <label class="block text-sm font-medium mb-1">{t('GENERAL.national')}</label>
                  <input
                    name="country"
                    value={user.country}
                    type="text"
                    class="w-full  border border-gray-300 rounded-lg px-4 py-2"
                    placeholder={t('GENERAL.national')}
                  />
                </div>
                <div>
                  <label class="block text-sm font-medium mb-1">{t('GENERAL.city')}</label>
                  <input
                    name="city"
                    value={user.city}
                    type="text"
                    class="w-full  border border-gray-300 rounded-lg px-4 py-2"
                    placeholder={t('GENERAL.city')}
                  />
                </div>
                <div>
                  <label class="block text-sm font-medium mb-1">{t('GENERAL.postalCode')}</label>
                  <input
                    name="postcode"
                    value={user.postcode}
                    type="text"
                    class="w-full  border border-gray-300 rounded-lg px-4 py-2"
                    placeholder={t('GENERAL.postalCode')}
                  />
                </div>
              </div>
            </form>
          </div>

          <div>
            <Agreements agreements={user?.agreements} />
            <div class="mt-10 flex justify-end">
              <button class={`bg-[${colors.mandy}] hover:bg-blue-700 text-white px-6 py-3 rounded-lg min-w-[200px]`}>Save changes</button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );

  // return (
  //   <Block xs={12} marginLeft="auto" marginRight="auto" marginTop={1}>
  //     <ChangePassword />
  //     <UserImage acc={user} />
  //     <Form onSubmit={handleSubmit}>
  //       <FlexRow xs={12} justifyContent="space-around">
  //         <PaperBlock xs={7} display="flex" justifyContent="space-around" flexWrap="wrap">
  //           <FlexRow xs={4} justifyContent="center">
  //             <HiddenField name="role" value={user.role} />
  //             <TextBox name="name" label={t('GENERAL.username')} value={user.name} />
  //             <TextBox name="email" label={t('GENERAL.email')} value={user.email} required={true} email={true} />
  //             <TextBox name="firstname" label={t('GENERAL.name')} value={user.firstname} />
  //             <TextBox name="lastname" label={t('GENERAL.surname')} value={user.lastname} />
  //             <RadioGroupBox row={true} name="gender" value={user.gender} options={genderOptions} />
  //             <DateTimePicker dateFieldName="birthday" label={t('GENERAL.dateofbirth')} value={user.birthday} disablePast={false} />
  //           </FlexRow>
  //           <FlexRow xs={4} justifyContent="center">
  //             <TextBox name="address" label={t('GENERAL.address')} value={user.address} />
  //             <TextBox name="city" label={t('GENERAL.city')} value={user.city} />
  //             <TextBox name="postcode" label={t('GENERAL.postalCode')} value={user.postcode} />
  //             <TextBox name="country" label={t('GENERAL.national')} value={user.country} />
  //             <TextBox name="phone" label={t('GENERAL.phone')} value={user.phone} />
  //           </FlexRow>
  //         </PaperBlock>
  //         <Agreements agreements={user?.agreements} />
  //       </FlexRow>
  //     </Form>
  //   </Block>
  // );
};

export default EditProfile;
